import React, { Component } from 'react';
import Iconc from 'components/Iconc';
import {observer} from 'mobx-react';
import envStore from '../request/model';
import './index.styl';

const clzpre = 'env-devicetree';

@observer
class DeviceTree extends Component {
    onNodeClick = (device) => this.props.onNodeClick(device);

    getTreeDom = () => {
        const {devices} = this.props.envStore;
        const {current} = this.props;
        return devices.map((d) => (
            <li className={current === d.id ? 'active' : ''} key={d.id}>
                <p onClick={() => this.onNodeClick(d)}>
                    <Iconc type='huabanfuben' />
                    <span>{d.name}</span>
                </p>
            </li>
        ));
    }

    render() {
        return <aside className={`${clzpre} com-bg`}>
            <h3>设备列表</h3>
            <ul>
                {this.getTreeDom()}
            </ul>
        </aside>
    }
}

export default (props) => <DeviceTree {...props} envStore={envStore} />;